<template>
  <div class="comparison-table-wrapper">
    <table class="comparison-table">
      <thead>
        <tr>
          <th class="head-attr"></th>
          <th
            v-for="subject in spec.subjects"
            :key="subject"
            class="head-subject"
          >
            {{ subject }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(attr, rowIdx) in spec.attributes"
          :key="attr.label"
          :class="{ 'row-stripe': rowIdx % 2 === 1 }"
        >
          <td class="cell-attr">{{ attr.label }}</td>
          <td
            v-for="(value, colIdx) in attr.values"
            :key="colIdx"
            class="cell-value"
          >
            <!--
              Reuse MarkdownContent so cell values support the same formatting
              and chip conventions as the rest of the response (bold, inline
              code, RM references as chips).
            -->
            <MarkdownContent
              :text="value || ''"
              :document-index="documentIndex"
              @ref-click="(refData, event) => $emit('ref-click', refData, event)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

/*
 * Circular-import dance:
 *   MarkdownContent → ChartView → ComparisonTable → MarkdownContent
 *
 * Importing MarkdownContent statically here resolves to an empty module
 * object on first load (Vue 2 + webpack eval order), which makes the
 * component register as undefined and cells render nothing. Async import
 * defers resolution to render time, breaking the cycle. Vue 3 doesn't
 * have this problem — its runtime resolution sees the real component by
 * the time the template renders.
 */
export default defineComponent({
  name: 'ComparisonTable',
  components: {
    MarkdownContent: () => import('../MarkdownContent.vue'),
  },
  props: {
    spec: { type: Object, required: true },
    documentIndex: { type: Map, default: null },
  },
  emits: ['ref-click'],
});
</script>

<style scoped>
.comparison-table-wrapper {
  width: 100%;
  overflow-x: auto;
}
.comparison-table {
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
}
.head-attr,
.head-subject {
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid rgb(229 231 235);
}
.head-attr {
  padding-left: 0;
  padding-right: 12px;
  font-weight: 500;
  color: rgb(107 114 128);
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
}
.head-subject {
  font-weight: 600;
  color: rgb(17 24 39);
}
.row-stripe {
  background: rgb(249 250 251);
}
.cell-attr {
  padding: 8px 12px 8px 0;
  color: rgb(107 114 128);
  font-size: 12px;
  vertical-align: top;
}
.cell-value {
  padding: 8px 12px;
  color: rgb(17 24 39);
  vertical-align: top;
}
</style>
